import { z } from "zod";

export const EVENT_FEATURE_KEYS = [
  "performers",
  "rehearsals",
  "event_shows",
  "documents",
  "commissions",
  "staff",
  "production_costs",
  "outsources",
] as const;

export const EventFeatureKeySchema = z.enum(EVENT_FEATURE_KEYS);
export type EventFeatureKey = z.infer<typeof EventFeatureKeySchema>;

export const EventFeaturesSchema = z.object({
  performers: z.boolean(),
  rehearsals: z.boolean(),
  event_shows: z.boolean(),
  documents: z.boolean(),
  commissions: z.boolean(),
  staff: z.boolean(),
  production_costs: z.boolean(),
  outsources: z.boolean(),
});
export type EventFeaturesDTO = z.infer<typeof EventFeaturesSchema>;

export const EventFeaturePresetSchema = z.enum([
  "performance_show",
  "manual_event",
  "organizer_kol_media",
  "custom",
]);
export type EventFeaturePreset = z.infer<typeof EventFeaturePresetSchema>;

export const EVENT_FEATURES_PERFORMANCE_SHOW: EventFeaturesDTO = {
  performers: true,
  rehearsals: true,
  event_shows: true,
  documents: true,
  commissions: true,
  staff: false,
  production_costs: true,
  outsources: false,
};

export const EVENT_FEATURES_MANUAL_EVENT: EventFeaturesDTO = {
  performers: false,
  rehearsals: false,
  event_shows: false,
  documents: true,
  commissions: true,
  staff: true,
  production_costs: true,
  outsources: false,
};

export const EVENT_FEATURES_ORGANIZER_KOL_MEDIA: EventFeaturesDTO = {
  performers: false,
  rehearsals: false,
  event_shows: false,
  documents: true,
  commissions: true,
  staff: false,
  production_costs: true,
  outsources: true,
};

export const EVENT_FEATURES_DEFAULT: EventFeaturesDTO =
  EVENT_FEATURES_PERFORMANCE_SHOW;
